import Boom from 'boom'
import makeApi from '../client/api'

export const applyVoucher = async (consulted_cpf, code, token) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const response = await api.post('/credit/raw-consult/apply-personal-voucher', { consulted_cpf, code })
  const { ok, data } = response

  if (!ok) {
    throw data.error
  }

  return data
}

export const purchaseRawConsult = async (creditcard_data, consulted_cpf, description, token) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const { ok, data } = await api.post('/credit/raw-consult/buy', {
    creditcard_data,
    consulted_cpf,
    description,
  })

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}

export const consultRawCPF = async (cpf, token) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const { ok, data } = await api.get('/credit/raw-consult/', { cpf })

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}
